import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const ProfileIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      d="M12 11.4a2.816 2.816 0 0 1-2.066-.857 2.816 2.816 0 0 1-.857-2.066c0-.807.285-1.495.857-2.066A2.816 2.816 0 0 1 12 5.554c.806 0 1.495.285 2.066.857.571.57.857 1.26.857 2.066 0 .806-.286 1.495-.857 2.066A2.816 2.816 0 0 1 12 11.4Zm-6.862 7.015v-1.553c0-.404.116-.779.347-1.124.23-.346.548-.615.952-.81.937-.442 1.87-.776 2.796-1.002.928-.226 1.85-.338 2.767-.338.918 0 1.84.112 2.769.338.928.225 1.86.559 2.797 1.002.402.194.72.464.95.81.23.345.346.72.346 1.123v1.554H5.137Zm.924-.923h11.876v-.628c0-.227-.071-.437-.214-.631a1.817 1.817 0 0 0-.596-.503c-.823-.397-1.665-.7-2.525-.907a11.046 11.046 0 0 0-5.213 0c-.857.208-1.694.51-2.508.907-.261.14-.463.31-.606.505a1.043 1.043 0 0 0-.214.627v.63ZM12 10.477c.55 0 1.02-.196 1.412-.588.392-.391.588-.862.588-1.412 0-.55-.196-1.02-.588-1.413A1.926 1.926 0 0 0 12 6.477c-.55 0-1.02.196-1.412.587A1.926 1.926 0 0 0 10 8.477c0 .55.196 1.02.588 1.412.391.392.862.588 1.412.588Z"
    />
  </Svg>
)
export default ProfileIcon
